import { Suspense } from "react"
import BookingModeContent from "@/app/booking/mode/booking-mode-content"
import BookingModeSkeleton from "@/components/booking-mode-skeleton"

export default function BookingModePage() {
  return (
    <Suspense fallback={<BookingModeSkeleton />}>
      <BookingModeContent />
    </Suspense>
  )
}
